import { BaseModel } from "sjs-base-model";

// InfluencerDashboardPutModel
export default class InfluencerDashboardPutModel extends BaseModel {
  /*
   * Client-Side properties (Not from API)
   */
  // noneApiProperties = null;
  // response getting from the api mentioned end point
  // message = "";
  status = "";

  constructor(data) {
    super();
    this.update(data);
  }
}
